export interface Drama {
  id: number;
  title: string;
  cover: string;
  category: string;
  categorySlug: string;
  region: string;
  year: number;
  rating: number;
  description: string;
  episodeCount: number;
  status: '更新中' | '已完结';
  actors: string[];
  director: string;
  updateInfo: string;
  featured: boolean;
}

export const categories = [
  { name: '国产剧', slug: 'guochan' },
  { name: '韩剧', slug: 'hanju' },
  { name: '美剧', slug: 'meiju' },
  { name: '日剧', slug: 'riju' },
  { name: '港剧', slug: 'gangju' },
  { name: '台剧', slug: 'taiju' },
  { name: '泰剧', slug: 'taiju2' },
];

export const regions = [
  { name: '全部地区', slug: 'all' },
  { name: '中国大陆', slug: 'mainland' },
  { name: '韩国', slug: 'korea' },
  { name: '美国', slug: 'usa' },
  { name: '日本', slug: 'japan' },
  { name: '中国香港', slug: 'hongkong' },
  { name: '中国台湾', slug: 'taiwan' },
];

export const years = [
  { name: '全部年份', slug: 'all' },
  { name: '2026', slug: '2026' },
  { name: '2025', slug: '2025' },
  { name: '2024', slug: '2024' },
  { name: '2023', slug: '2023' },
  { name: '2020-2022', slug: '2020-2022' },
  { name: '2010年代', slug: '2010s' },
  { name: '更早', slug: 'older' },
];

export const dramas: Drama[] = [
  {
    id: 1,
    title: '繁花',
    cover: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%20period%20drama%20poster%20featuring%20a%20stylish%20woman%20in%201990s%20Shanghai%20dressed%20in%20vintage%20qipao%20with%20art%20deco%20neon%20lights%20in%20background%2C%20cinematic%20lighting%2C%20warm%20golden%20tones%2C%20film%20poster%20style%2C%20elegant%20composition%2C%20minimalist%20background&width=600&height=800&seq=drama-fanhua&orientation=portrait',
    category: '国产剧',
    categorySlug: 'guochan',
    region: '中国大陆',
    year: 2023,
    rating: 9.3,
    description: '九十年代的上海，机遇与挑战并存。阿宝凭借改革开放的春风和自己的打拼，成为商界后起之秀。黄河路上，人人都有故事，个个都有传奇。这是一部关于上海的往事，也是一代人的集体记忆。',
    episodeCount: 30,
    status: '已完结',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾'],
    director: '王家卫',
    updateInfo: '全30集',
    featured: true,
  },
  {
    id: 2,
    title: '狂飙',
    cover: 'https://readdy.ai/api/search-image?query=A%20gritty%20Chinese%20crime%20drama%20poster%20showing%20a%20determined%20police%20officer%20and%20a%20gangster%20facing%20each%20other%20in%20dark%20moody%20lighting%2C%20tense%20atmosphere%2C%20urban%20cityscape%20background%2C%20cinematic%20noir%20style%2C%20high%20contrast%20shadows%2C%20film%20poster%20aesthetic&width=600&height=800&seq=drama-kuangbiao&orientation=portrait',
    category: '国产剧',
    categorySlug: 'guochan',
    region: '中国大陆',
    year: 2023,
    rating: 9.1,
    description: '以一线刑警安欣为代表的正义力量，与黑恶势力展开长达二十年的生死搏斗。通过群像叙事，展现扫黑行动中的复杂人性与坚定信念。',
    episodeCount: 39,
    status: '已完结',
    actors: ['张译', '张颂文', '李一桐', '张志坚'],
    director: '徐纪周',
    updateInfo: '全39集',
    featured: true,
  },
  {
    id: 3,
    title: '黑暗荣耀',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20drama%20poster%20featuring%20an%20elegant%20woman%20with%20intense%20gaze%20in%20dark%20moody%20atmosphere%2C%20minimalist%20composition%2C%20cold%20color%20palette%20with%20subtle%20warm%20accents%2C%20film%20poster%20style%2C%20sophisticated%20and%20mysterious%20mood&width=600&height=800&seq=drama-glory&orientation=portrait',
    category: '韩剧',
    categorySlug: 'hanju',
    region: '韩国',
    year: 2023,
    rating: 9.0,
    description: '年少时遭受校园暴力的文东恩，经过多年谋划，对加害者和旁观者展开了一场精心策划的复仇。这是一部关于伤痛、复仇与救赎的暗黑故事。',
    episodeCount: 16,
    status: '已完结',
    actors: ['宋慧乔', '李到晛', '林智妍', '廉惠兰'],
    director: '安吉镐',
    updateInfo: '全16集',
    featured: true,
  },
  {
    id: 4,
    title: '长相思',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20fantasy%20costume%20drama%20poster%20with%20a%20woman%20in%20flowing%20ancient%20hanfu%20dress%20standing%20in%20a%20dreamy%20landscape%20with%20cherry%20blossoms%2C%20soft%20ethereal%20lighting%2C%20romantic%20atmosphere%2C%20film%20poster%20aesthetic%2C%20warm%20peach%20tones&width=600&height=800&seq=drama-zhangxiangsi&orientation=portrait',
    category: '国产剧',
    categorySlug: 'guochan',
    region: '中国大陆',
    year: 2024,
    rating: 8.8,
    description: '上古时期，人神妖混居。流落大荒的高辛王姬玖瑶历经磨难，在清水镇与神秘医师玟小六相遇，一段荡气回肠的爱情故事由此展开。',
    episodeCount: 39,
    status: '已完结',
    actors: ['杨紫', '张晚意', '邓为', '代露娃'],
    director: '秦榛',
    updateInfo: '全39集',
    featured: true,
  },
  {
    id: 5,
    title: '龙之家族',
    cover: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20drama%20poster%20featuring%20a%20majestic%20dragon%20silhouette%20against%20a%20fiery%20sky%20with%20a%20crown%20in%20foreground%2C%20dark%20and%20dramatic%20lighting%2C%20cinematic%20fantasy%20style%2C%20film%20poster%20aesthetic%2C%20rich%20dark%20red%20and%20black%20tones&width=600&height=800&seq=drama-hotd&orientation=portrait',
    category: '美剧',
    categorySlug: 'meiju',
    region: '美国',
    year: 2024,
    rating: 8.5,
    description: '故事背景设定在《权力的游戏》事件发生的两百年前，讲述坦格利安家族内战——"血龙狂舞"的故事，龙与权力的巅峰对决。',
    episodeCount: 8,
    status: '更新中',
    actors: ['艾玛·达西', '马特·史密斯', '奥利维亚·库克', '瑞斯·伊凡斯'],
    director: '克莱尔·基尔纳',
    updateInfo: '更新至6集',
    featured: false,
  },
  {
    id: 6,
    title: '重启人生',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20drama%20poster%20with%20a%20woman%20looking%20thoughtful%20in%20everyday%20modern%20setting%2C%20warm%20natural%20lighting%2C%20slice%20of%20life%20aesthetic%2C%20film%20poster%20style%2C%20soft%20and%20gentle%20color%20palette%2C%20minimalist%20composition&width=600&height=800&seq=drama-brushup&orientation=portrait',
    category: '日剧',
    categorySlug: 'riju',
    region: '日本',
    year: 2023,
    rating: 9.2,
    description: '33岁的单身女性近藤麻美，意外死亡后获得重新开始人生的机会。为了来世能投胎成人，她不断重启人生，积累功德。一部温暖治愈又脑洞大开的神作。',
    episodeCount: 10,
    status: '已完结',
    actors: ['安藤樱', '夏帆', '木南晴夏', '松坂桃李'],
    director: '水野格',
    updateInfo: '全10集',
    featured: false,
  },
  {
    id: 7,
    title: '新闻女王',
    cover: 'https://readdy.ai/api/search-image?query=A%20Hong%20Kong%20TV%20drama%20poster%20featuring%20a%20confident%20woman%20in%20sharp%20business%20attire%20in%20a%20modern%20newsroom%20setting%2C%20professional%20atmosphere%2C%20dramatic%20lighting%2C%20urban%20office%20backdrop%2C%20film%20poster%20style%2C%20sleek%20and%20modern&width=600&height=800&seq=drama-newsqueen&orientation=portrait',
    category: '港剧',
    categorySlug: 'gangju',
    region: '中国香港',
    year: 2023,
    rating: 8.7,
    description: 'SNK新闻部资深主播文慧心，为争夺晚间新闻主播之位，与竞争对手展开了一场明争暗斗的职场权力游戏。致敬每一位在职场中拼搏的女性。',
    episodeCount: 26,
    status: '已完结',
    actors: ['佘诗曼', '马国明', '李施嬅', '高海宁'],
    director: '钟澍佳',
    updateInfo: '全26集',
    featured: false,
  },
  {
    id: 8,
    title: '与恶魔有约',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20fantasy%20drama%20poster%20with%20a%20couple%20in%20elegant%20clothing%20facing%20each%20other%20with%20mystical%20sparks%20between%20them%2C%20dark%20moody%20background%20with%20golden%20light%2C%20film%20poster%20aesthetic%2C%20romantic%20and%20mysterious&width=600&height=800&seq=drama-devil&orientation=portrait',
    category: '韩剧',
    categorySlug: 'hanju',
    region: '韩国',
    year: 2023,
    rating: 8.4,
    description: '财阀继承人郑九元与恶魔杜度熙签订契约后，两人之间展开了一段既危险又甜蜜的奇幻爱情故事，契约的背后隐藏着更大的秘密。',
    episodeCount: 16,
    status: '已完结',
    actors: ['金裕贞', '宋江', '李相二', '金海淑'],
    director: '金正贤',
    updateInfo: '全16集',
    featured: false,
  },
  {
    id: 9,
    title: '三体',
    cover: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20Chinese%20drama%20poster%20with%20mysterious%20cosmic%20elements%2C%20three%20suns%20in%20the%20sky%2C%20a%20figure%20standing%20in%20a%20futuristic%20landscape%2C%20dark%20and%20atmospheric%2C%20cinematic%20science%20fiction%20style%2C%20film%20poster%20aesthetic%2C%20deep%20space%20background&width=600&height=800&seq=drama-threebody&orientation=portrait',
    category: '国产剧',
    categorySlug: 'guochan',
    region: '中国大陆',
    year: 2023,
    rating: 8.9,
    description: '纳米科学家汪淼闯入神秘的网络游戏《三体》，逐步揭开地球基础科学遭遇异常干扰的真相，并发现来自三体文明的巨大威胁。',
    episodeCount: 30,
    status: '已完结',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文'],
    director: '杨磊',
    updateInfo: '全30集',
    featured: true,
  },
  {
    id: 10,
    title: '想见你',
    cover: 'https://readdy.ai/api/search-image?query=A%20Taiwanese%20romance%20drama%20poster%20with%20a%20young%20couple%20looking%20at%20each%20other%20through%20a%20rainy%20window%2C%20nostalgic%20and%20melancholic%20atmosphere%2C%20warm%20lighting%20through%20raindrops%2C%20film%20poster%20style%2C%20tender%20and%20emotional&width=600&height=800&seq=drama-someday&orientation=portrait',
    category: '台剧',
    categorySlug: 'taiju',
    region: '中国台湾',
    year: 2019,
    rating: 9.2,
    description: '黄雨萱曾在1998-2019年间遇见并爱上了一个叫王诠胜的男孩，但在2019年，王诠胜死于空难。一次偶然的穿越，她发现自己可以回到过去，试图改变命运。',
    episodeCount: 13,
    status: '已完结',
    actors: ['柯佳嬿', '许光汉', '施柏宇', '颜毓麟'],
    director: '黄天仁',
    updateInfo: '全13集',
    featured: false,
  },
  {
    id: 11,
    title: '星期三',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20American%20drama%20poster%20with%20a%20gothic%20teenage%20girl%20in%20black%20dress%20with%20braids%2C%20dark%20academia%20aesthetic%2C%20mysterious%20atmosphere%2C%20film%20poster%20style%2C%20gothic%20and%20whimsical%2C%20purple%20and%20black%20color%20scheme&width=600&height=800&seq=drama-wednesday&orientation=portrait',
    category: '美剧',
    categorySlug: 'meiju',
    region: '美国',
    year: 2022,
    rating: 8.6,
    description: '星期三·亚当斯被父母送进奈弗莫尔学院，在这里她不仅要掌握自己的超能力，还要阻止一场可怕的杀戮狂潮，解开25年前困扰她父母的超自然之谜。',
    episodeCount: 8,
    status: '已完结',
    actors: ['珍娜·奥尔特加', '格温多兰·克里斯蒂', '凯瑟琳·泽塔-琼斯'],
    director: '蒂姆·伯顿',
    updateInfo: '全8集',
    featured: false,
  },
  {
    id: 12,
    title: '莲花楼',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20drama%20poster%20with%20a%20warrior%20in%20flowing%20white%20robes%20standing%20on%20a%20misty%20mountain%20peak%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20ethereal%20atmosphere%2C%20film%20poster%20style%2C%20elegant%20and%20mysterious&width=600&height=800&seq=drama-lianhualou&orientation=portrait',
    category: '国产剧',
    categorySlug: 'guochan',
    region: '中国大陆',
    year: 2023,
    rating: 8.7,
    description: '曾经叱咤风云的四顾门门主李相夷在东海大战后消失十年，化名李莲花行走江湖。一幢会移动的莲花楼，一桩桩离奇诡案，他的真实身份也渐渐浮出水面。',
    episodeCount: 40,
    status: '已完结',
    actors: ['成毅', '曾舜晞', '肖顺尧', '陈都灵'],
    director: '郭虎',
    updateInfo: '全40集',
    featured: false,
  },
  {
    id: 13,
    title: '我的解放日志',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20slice%20of%20life%20drama%20poster%20with%20three%20siblings%20walking%20on%20a%20quiet%20countryside%20road%20at%20sunset%2C%20warm%20golden%20lighting%2C%20peaceful%20and%20healing%20atmosphere%2C%20film%20poster%20style%2C%20simple%20and%20honest%20composition&width=600&height=800&seq=drama-liberation&orientation=portrait',
    category: '韩剧',
    categorySlug: 'hanju',
    region: '韩国',
    year: 2022,
    rating: 9.1,
    description: '京畿道三兄妹每天往返首尔通勤，在日复一日的平凡生活中寻找人生的出口。一个神秘的外地男人入驻村庄，平静的生活开始有了变化。',
    episodeCount: 16,
    status: '已完结',
    actors: ['李民基', '金智媛', '孙锡久', '李艾'],
    director: '金锡允',
    updateInfo: '全16集',
    featured: false,
  },
  {
    id: 14,
    title: '苍兰诀',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20fantasy%20romance%20drama%20poster%20with%20a%20couple%20in%20elaborate%20ancient%20costumes%20surrounded%20by%20magical%20glowing%20orchids%2C%20dreamy%20fantasy%20atmosphere%2C%20soft%20purple%20and%20gold%20lighting%2C%20film%20poster%20aesthetic%2C%20romantic%20and%20magical&width=600&height=800&seq=drama-canglanjue&orientation=portrait',
    category: '国产剧',
    categorySlug: 'guochan',
    region: '中国大陆',
    year: 2022,
    rating: 8.5,
    description: '一个卑微的小兰花修成人形，意外遇上了被困于昊天塔的三界第一强者东方青苍。两人阴差阳错地交换了身体，一段跨越三界的爱情故事就此展开。',
    episodeCount: 36,
    status: '已完结',
    actors: ['虞书欣', '王鹤棣', '徐海乔', '郭晓婷'],
    director: '伊峥',
    updateInfo: '全36集',
    featured: false,
  },
  {
    id: 15,
    title: '弥留之国的爱丽丝',
    cover: 'https://readdy.ai/api/search-image?query=A%20Japanese%20survival%20thriller%20drama%20poster%20showing%20a%20group%20of%20people%20in%20a%20deserted%20Tokyo%20cityscape%20with%20playing%20cards%20falling%20from%20the%20sky%2C%20dystopian%20atmosphere%2C%20tense%20and%20dark%2C%20film%20poster%20style%2C%20high%20stakes&width=600&height=800&seq=drama-alice&orientation=portrait',
    category: '日剧',
    categorySlug: 'riju',
    region: '日本',
    year: 2022,
    rating: 8.6,
    description: '有栖良平与两个好友突然从日常世界坠入一个荒废的平行东京，被迫参加一场又一场残酷的生存游戏。每一张扑克牌都代表一个不同的死亡挑战。',
    episodeCount: 8,
    status: '已完结',
    actors: ['山崎贤人', '土屋太凤', '村上虹郎', '三吉彩花'],
    director: '佐藤信介',
    updateInfo: '全8集',
    featured: false,
  },
  {
    id: 16,
    title: '漫长的季节',
    cover: 'https://readdy.ai/api/search-image?query=A%20Chinese%20suspense%20drama%20poster%20set%20in%20northeast%20China%20with%20a%20middle-aged%20man%20in%20worn%20coat%20standing%20in%20snowy%20industrial%20townscape%2C%20nostalgic%201990s%20aesthetic%2C%20melancholic%20atmosphere%2C%20film%20poster%20style%2C%20cold%20winter%20tones&width=600&height=800&seq=drama-longseason&orientation=portrait',
    category: '国产剧',
    categorySlug: 'guochan',
    region: '中国大陆',
    year: 2023,
    rating: 9.4,
    description: '出租车司机王响、妹夫龚彪、刑警马德胜三人因为一桩跨越二十年的悬案再次聚首。在东北小城寒冷的冬天里，他们不仅要面对谜团，更要面对各自坎坷的命运。',
    episodeCount: 12,
    status: '已完结',
    actors: ['范伟', '秦昊', '陈明昊', '李庚希'],
    director: '辛爽',
    updateInfo: '全12集',
    featured: true,
  },
];

export const articles = [
  {
    id: 1,
    title: '2024年必看的十部高分国产剧，每一部都值得二刷',
    excerpt: '今年国产剧市场迎来了一波质量爆发，从古装到现代，从悬疑到爱情，各种类型全面开花。我们整理了十部口碑炸裂的国产好剧。',
    content: '2024年国产剧市场可谓是百花齐放，从年初的《繁花》到年中的《长相思》第二季，再到年末的《庆余年》第二季，每一部都在社交媒体上引发了热烈的讨论。这些剧集不仅在制作上更加精良，在剧情编排和人物塑造上也更加成熟，展现了中国电视剧行业蓬勃发展的新气象...',
    category: '国产剧',
    date: '2024-06-15',
    author: '追剧小助手',
    views: 15680,
  },
  {
    id: 2,
    title: '韩剧迷必收！2024年上半年最值得追的韩剧清单',
    excerpt: '从甜蜜爱情到悬疑惊悚，从奇幻穿越到现实职场，2024年上半年的韩剧市场精彩纷呈，总有一部会让你欲罢不能。',
    content: '2024年韩剧圈依旧保持了高水准的制作质量，上半年涌现了多部口碑作品。无论是老牌演员的回归之作，还是新生代演员的突破表现，都让剧迷们大饱眼福...',
    category: '韩剧',
    date: '2024-05-20',
    author: '韩剧控',
    views: 12340,
  },
  {
    id: 3,
    title: '豆瓣9分以上的经典美剧推荐，剧荒必看',
    excerpt: '这些在豆瓣上评分超过9分的美剧，每一部都是经过时间考验的经典之作，无论是剧情深度还是制作水准都堪称一流。',
    content: '美剧市场从来不缺好作品，但能在豆瓣获得9分以上的美剧，绝对是可以载入史册的神作级别。从《绝命毒师》到《权力的游戏》前几季，这些剧集不仅仅是娱乐，更是艺术...',
    category: '美剧',
    date: '2024-04-10',
    author: '美剧达人',
    views: 18920,
  },
  {
    id: 4,
    title: '日剧推荐：那些治愈人心的温暖日剧',
    excerpt: '日剧有一种独特的魅力，它们用细腻的笔触描绘普通人的生活，在平淡中见真情，在细微处显温暖。',
    content: '日剧的魅力在于它们不追求跌宕起伏的戏剧冲突，而是用心刻画人物的内心世界和日常生活中的小确幸。从《深夜食堂》到《重启人生》，这些作品教会我们珍惜当下，感恩生活...',
    category: '日剧',
    date: '2024-03-25',
    author: '日剧爱好者',
    views: 9870,
  },
  {
    id: 5,
    title: '港剧回春！近几年最值得看的港剧盘点',
    excerpt: '港剧近几年呈现回暖趋势，一批制作精良、剧情扎实的作品让观众重新找回了"港味"的魅力。',
    content: '曾几何时，港剧是华语电视剧的标杆。虽然经历过一段低谷期，但近几年的港剧明显在回升，从题材创新到制作水准都有了显著提升...',
    category: '港剧',
    date: '2024-02-18',
    author: '港剧情怀',
    views: 7650,
  },
  {
    id: 6,
    title: '2024年台剧突围：小而美的精品路线',
    excerpt: '台剧近年来走出了一条精品化路线，虽然产量不高，但几乎每部都是用心之作，口碑与品质双双在线。',
    content: '从《我们与恶的距离》到《想见你》，再到去年的《人选之人—造浪者》，台剧正在用一部部精品证明：不一定要大制作，用心讲好故事才是关键...',
    category: '台剧',
    date: '2024-01-30',
    author: '追剧小助手',
    views: 6540,
  },
];

export const siteInfo = {
  name: '6080影视',
  description: '6080影视专注电视剧全集免费播放，高清不缓冲在线观看，涵盖最新热播剧、经典老剧、高分剧集。流畅播放超清画质，海量免费电视剧每日更新，不用等缓冲就能免费看全集。',
  founded: '2018年',
  email: 'contact@6080ys.com',
  phone: '400-888-6080',
  address: '北京市朝阳区建国路88号',
  stats: {
    totalDramas: '50000+',
    dailyVisitors: '200万+',
    updateSpeed: '每日更新',
    userRating: '4.9/5.0',
  },
};